export class GetTokenResult {
    oneTimeToken = "";
    url = "";
}
